import { HttpClient, RequestConfig } from "@planzone/services";

function createUaaUrlProvider(httpClient: HttpClient): HttpClient {
  return {
    sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
      return httpClient.sendHttpRequest({
        baseUrl: "/uaa",
        ...config,
      });
    },
  };
}

export { createUaaUrlProvider };
